<div class="container-fluid">
    <div class="row">
        <div class="col-8 mb-5 border-bottom">
            <h1 class="primary-color pt-3">{{title}} <small class="text-muted" *ngIf="subTitle">{{ subTitle }}</small></h1>
        </div>
        <div class="col-4 mb-5 border-bottom text-right">
            <ng-content select="button"></ng-content>
            <ng-content select="div"></ng-content>
        </div>
    </div>
</div>